import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)),
  hub: defineAsyncComponent(() => import("/opt/build/repo/layouts/hub.vue").then(m => m.default || m)),
  "hub-blank": defineAsyncComponent(() => import("/opt/build/repo/layouts/hubBlank.vue").then(m => m.default || m)),
  "no-auth": defineAsyncComponent(() => import("/opt/build/repo/layouts/noAuth.vue").then(m => m.default || m)),
  onboarding: defineAsyncComponent(() => import("/opt/build/repo/layouts/onboarding.vue").then(m => m.default || m))
}